import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-clear-button',
    templateUrl: './clear-button.component.html',
})
export class ClearButtonComponent {
    @Input('element') element: any;
    @Input('isShow') isShow;

    constructor() {
    }

    clear() {
        this.element.control.setValue('');
        this.isShow = false;
    }
}
